import { useEffect } from "react";

const SchemaMarkup = () => {
  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "BeautySalon",
          "@id": "https://www.thefacebyanahit.com/",
          "name": "The Face By Anahit",
          "sameAs": [
            "https://www.instagram.com/thefacebyanahit"
          ],
          "description": "Professional makeup artist offering bridal makeup, special occasion makeup, and personalized beauty services in Glendale, CA.",
          "employee": {
            "@type": "Person",
            "name": "Anahit",
            "jobTitle": "Makeup Artist"
          },
          "openingHours": "Mo,Tu,We,Th,Fr,Sa,Su 06:00-19:00",
          "telephone": "7473065251",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "225 W Broadway #20",
            "addressLocality": "Glendale",
            "addressRegion": "CA",
            "postalCode": "91204",
            "addressCountry": "US"
          },
          "priceRange": "$170 - $400",
          "paymentAccepted": "Cash, Credit Card, Debit Card",
          "image": process.env.REACT_APP_THE_FACE_BY_ANAHIT,
          "email": "mailto:thefacebyanahit@gmail.com",
          "url": "https://www.thefacebyanahit.com",
          "areaServed": {
            "@type": "AdministrativeArea",
            "name": "Los Angeles County"
          }
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Where are you located?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "I'm based in Glendale, California and serve clients throughout Los Angeles County."
              }
            },
            {
              "@type": "Question",
              "name": "Do you offer bridal makeup?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, I specialize in bridal makeup, including bridal trials and wedding-day services."
              }
            },
            {
              "@type": "Question",
              "name": "Do you travel for weddings?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, I am available to travel for weddings and special events upon request."
              }
            },
            {
              "@type": "Question",
              "name": "How far in advance should I book?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "For weddings, I recommend booking at least 3-6 months in advance to secure your date."
              }
            },
            {
              "@type": "Question",
              "name": "Do you offer makeup trials?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, makeup trials are available and highly recommended for brides before the wedding day."
              }
            },
            {
              "@type": "Question",
              "name": "Do you offer regular makeup services?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, I provide regular makeup services for everyday occasions, photoshoots, and special events."
              }
            },
            {
              "@type": "Question",
              "name": "What are your prices for makeup services?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "My makeup services range from $170 to $400, depending on the type of service and event. Please contact me for a personalized quote."
              }
            },
            {
              "@type": "Question",
              "name": "Who is Anahit?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Anahit is a professional makeup artist based in Glendale, California, specializing in bridal and special occasion makeup with years of experience creating beautiful looks for her clients."
              }
            },
            {
              "@type": "Question",
              "name": "Do you have experience working with celebrities?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, I have had the privilege of working with several celebrity clients, providing professional makeup services for events, photoshoots, and appearances."
              }
            },
            {
              "@type": "Question",
              "name": "What types of makeup products do you use?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "I use high-quality, professional-grade, hypoallergenic makeup products suitable for all skin types, including cruelty-free and vegan options upon request."
              }
            },
            {
              "@type": "Question",
              "name": "How long does a typical makeup session last?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "A regular makeup session usually lasts between 45 minutes to 1.5 hours depending on the service."
              }
            },
            {
              "@type": "Question",
              "name": "Do you offer makeup services for non-bride special occasions?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, I provide makeup services for special occasions, photo shoots, and any event where you want to look your best."
              }
            },
            {
              "@type": "Question",
              "name": "What is your cancellation or rescheduling policy?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "I require at least 48 hours notice for cancellations or rescheduling to avoid fees."
              }
            },
            {
              "@type": "Question",
              "name": "Can you do makeup for large bridal parties?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, I can accommodate bridal parties of all sizes. Please contact me early to ensure availability."
              }
            },
            {
              "@type": "Question",
              "name": "Do you provide on-location makeup services?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, I travel to homes, hotels, and event venues in Glendale and the greater Los Angeles area."
              }
            },
            {
              "@type": "Question",
              "name": "Do you offer hair styling services as well?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Currently, I specialize in makeup services only, but I work closely with trusted hairstylists and can provide recommendations."
              }
            },
            {
              "@type": "Question",
              "name": "How do I prepare for my makeup appointment?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Arrive with a clean, moisturized face and avoid applying heavy skincare products or other makeup."
              }
            },
            {
              "@type": "Question",
              "name": "Do you offer group or package deals?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, I offer special rates for bridal parties and group bookings. Please contact me for details."
              }
            },
            {
              "@type": "Question",
              "name": "How do I book an appointment?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "You can book via my website, Instagram direct message, or email at thefacebyanahit@gmail.com."
              }
            }
          ]
        }
      ]
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
};

export default SchemaMarkup;
